export default function AboutSection() {
  return (
    <section id="about" className="relative overflow-hidden bg-gradient-to-b from-[#F8FBFF] via-white to-[#EEF6FF] py-24 md:py-28">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[-10%] top-10 h-64 w-64 rounded-full bg-[#38BDF8]/10 blur-3xl" />
        <div className="absolute right-[-8%] top-1/3 h-72 w-72 rounded-full bg-[#0B1F3A]/[0.05] blur-3xl" />
        <div className="absolute left-1/3 bottom-[-10%] h-80 w-80 rounded-full bg-[#60A5FA]/10 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid gap-10 xl:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] items-start">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-[#BFDBFE] bg-white/90 px-4 py-2 shadow-[0_10px_30px_rgba(11,31,58,0.06)]">
              <span className="inline-flex h-2.5 w-2.5 rounded-full bg-[#38BDF8]" />
              <span className="text-[0.68rem] md:text-[0.72rem] font-semibold tracking-[0.22em] uppercase text-[#123E7A]">
                AbschleppDirekt24 · Privat & Direkt
              </span>
            </div>

            <h2 className="mt-6 max-w-4xl text-3xl md:text-5xl lg:text-[3.35rem] font-semibold leading-[1.05] text-[#0B1F3A]">
              Schnelle Hilfe statt Club-Warteschleife. Direkt erreichbar, klar kommuniziert, sauber koordiniert.
            </h2>

            <p className="mt-6 max-w-3xl text-base md:text-xl leading-relaxed text-[#1E3A5F]">
              AbschleppDirekt24 steht für direkte Erreichbarkeit, klare Kommunikation und schnelle Hilfe im Einsatzfall. Der Fokus liegt auf Pannendienst, Fahrzeugbergung und Falschparker-Abschleppung in Berlin & Umgebung.
            </p>

            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              <div className="rounded-3xl border border-[#BFDBFE] bg-white/95 p-5 shadow-[0_18px_50px_rgba(11,31,58,0.06)]">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E0F2FE] text-[#0B1F3A]">
                  <i className="ri-phone-line text-xl" />
                </div>
                <p className="text-2xl font-semibold text-[#0B1F3A]">24/7</p>
                <p className="mt-1 text-xs uppercase tracking-[0.18em] text-[#123E7A]/70">Direkt erreichbar</p>
                <p className="mt-3 text-sm leading-relaxed text-[#1E3A5F]">
                  Keine Hotline-Kaskaden. Direkter Kontakt für schnelle Einsatzannahme.
                </p>
              </div>

              <div className="rounded-3xl border border-[#BFDBFE] bg-white/95 p-5 shadow-[0_18px_50px_rgba(11,31,58,0.06)]">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E0F2FE] text-[#0B1F3A]">
                  <i className="ri-map-pin-line text-xl" />
                </div>
                <p className="text-2xl font-semibold text-[#0B1F3A]">Berlin</p>
                <p className="mt-1 text-xs uppercase tracking-[0.18em] text-[#123E7A]/70">Alle Bezirke + Umland</p>
                <p className="mt-3 text-sm leading-relaxed text-[#1E3A5F]">
                  Von Innenstadt bis Randbezirk. Einsätze flexibel nach Lage und Distanz.
                </p>
              </div>

              <div className="rounded-3xl border border-[#BFDBFE] bg-white/95 p-5 shadow-[0_18px_50px_rgba(11,31,58,0.06)] sm:col-span-2 lg:col-span-1">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E0F2FE] text-[#0B1F3A]">
                  <i className="ri-shield-check-line text-xl" />
                </div>
                <p className="text-2xl font-semibold text-[#0B1F3A]">Transparent</p>
                <p className="mt-1 text-xs uppercase tracking-[0.18em] text-[#123E7A]/70">Ablauf & Dokumentation</p>
                <p className="mt-3 text-sm leading-relaxed text-[#1E3A5F]">
                  Verständliche Infos vorab und nachvollziehbare Dokumentation auf Wunsch.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-5">
            <div className="rounded-[2rem] border border-[#123E7A] bg-[#0B1F3A] p-6 md:p-7 shadow-[0_28px_80px_rgba(11,31,58,0.18)]">
              <div className="flex items-center justify-between gap-4">
                <div>
                  <p className="text-[0.68rem] uppercase tracking-[0.22em] text-[#7DD3FC]">Service-Prinzip</p>
                  <h3 className="mt-2 text-xl md:text-2xl font-semibold text-white">Privat. Direkt. Klar.</h3>
                </div>
                <div className="flex h-14 w-14 items-center justify-center rounded-3xl bg-[#38BDF8] text-[#0B1F3A] shrink-0">
                  <i className="ri-roadster-line text-2xl" />
                </div>
              </div>

              <div className="mt-6 space-y-4">
                <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                  <p className="text-sm font-medium text-white">Pannenhilfe & Fahrzeugbergung</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/70">
                    Schnelle Hilfe bei Defekten, Startproblemen, Unfällen und nicht fahrbereiten Fahrzeugen.
                  </p>
                </div>
                <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                  <p className="text-sm font-medium text-white">Falschparker auf Privatgrund</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/70">
                    Dokumentierte Abschleppung blockierender Fahrzeuge auf privaten Flächen und Zufahrten.
                  </p>
                </div>
                <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                  <p className="text-sm font-medium text-white">24/7 Hilfe in Sonderfällen</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/70">
                    Unterstützung auch bei blockierten Zufahrten, Tiefgaragen und schwierigen Einsatzsituationen.
                  </p>
                </div>
              </div>
            </div>

            <div className="grid gap-5 md:grid-cols-2">
              <div className="rounded-[1.75rem] border border-[#BFDBFE] bg-white/95 p-5 shadow-[0_18px_50px_rgba(11,31,58,0.06)]">
                <p className="text-[0.68rem] uppercase tracking-[0.2em] text-[#123E7A]">Unser Anspruch</p>
                <p className="mt-3 text-lg font-semibold text-[#0B1F3A]">Schnell vor Ort. Klar im Ablauf.</p>
                <p className="mt-3 text-sm leading-relaxed text-[#1E3A5F]">
                  Direkter Kontakt, kurze Reaktionszeiten und ein sauberer Ablauf vom ersten Anruf bis zur professionellen Umsetzung vor Ort.
                </p>
              </div>

              <div className="rounded-[1.75rem] border border-[#38BDF8]/25 bg-gradient-to-br from-[#102845] to-[#0B1F3A] p-5 shadow-[0_18px_50px_rgba(11,31,58,0.12)]">
                <p className="text-[0.68rem] uppercase tracking-[0.2em] text-[#7DD3FC]">Einsatzgebiet</p>
                <p className="mt-3 text-lg font-semibold text-white">Berlin & Umgebung</p>
                <p className="mt-3 text-sm leading-relaxed text-white/75">
                  Mitte, Neukölln, Kreuzberg, Pankow, Charlottenburg und angrenzendes Umland je nach Einsatzlage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}